<script setup>
import { getConstants } from "@/configs/constants.js";

const getConfig = getConstants();
</script>

<template>
  <footer id="footer-container-app" class="flex-none bg-gradient-blue lg:py-4">
    <div
      class="flex w-full justify-between md:flex-row flex-col-reverse items-center md:items-start"
    >
      <!-- <div class="ms-2 mt-2 order-1 md:mt-0 md:order-2">
        <a href="/" class="">
          <img
            class="footer-img-logo"
            src="@/assets/imgs/app/logo-footer.png"
          />
        </a>
      </div> -->
      <div class="ms-2 mt-2 md:mt-0 md:order-1">
        <div
          class="flex flex-wrap space-x-1 text-sm md:text-base lg:text-lg xl:text-xl justify-center md:justify-start"
        >
          <span class="text-white">
            Copyright © {{ new Date().getFullYear() }} /
          </span>
          <a class="text-white text-uppercase underline font-bold" href="/">
            {{ getConfig.SYSTEM_OWNER_NAME }}
          </a>
          <span class="font-white">/ Versão: </span>
          <span class="font-red">{{ getConfig.SYSTEM_VERSION }}</span>
        </div>
      </div>
    </div>
  </footer>
</template>
